import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, ProtectedRoute, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Ingredients from "./pages/Ingredients";
import IngredientDetail from "./pages/IngredientDetail";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import Purchases from "./pages/Purchases";
import Profile from "./pages/Profile";
import Stats from "./pages/Stats";
import Suppliers from "./pages/Suppliers";
import Orders from "./pages/Orders";
import BeverageCost from "./pages/BeverageCost";
import Billing from "./pages/Billing";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Guide from "./pages/Guide";
import { CookieBanner } from "./components/CookieBanner";
import { SuperAdminFab } from "./components/SuperAdminFab";
import { Toaster } from "./components/ui/sonner";

function GuestOnly({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/dashboard" replace />;
    return children;
}

function AppContent() {
    const location = useLocation();
    // Synchronous OAuth callback detection — must run BEFORE ProtectedRoute
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/ingredients" element={<ProtectedRoute><Ingredients /></ProtectedRoute>} />
            <Route path="/ingredients/:id" element={<ProtectedRoute><IngredientDetail /></ProtectedRoute>} />
            <Route path="/recipes" element={<ProtectedRoute><Recipes /></ProtectedRoute>} />
            <Route path="/recipes/:id" element={<ProtectedRoute><RecipeDetail /></ProtectedRoute>} />
            <Route path="/purchases" element={<ProtectedRoute><Purchases /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/beverage-cost" element={<ProtectedRoute><BeverageCost /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/guide" element={<ProtectedRoute><Guide /></ProtectedRoute>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function GlobalFabs() {
    const location = useLocation();
    // Non mostrare il pulsante SA quando si è già sulla pagina admin
    if (location.pathname.startsWith("/admin")) return null;
    if (location.hash?.includes("session_id=")) return null;
    return <SuperAdminFab />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster position="top-right" />
                    <AppContent />
                    <GlobalFabs />
                    <CookieBanner />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
